import cx from 'classnames';
import { selfRatingOptions } from './constants';
import styles from './styles.scss';

interface SelfRatingPopoverProps {
  onSetSelfRating: (rating: number) => void;
}

export const SelfRatingPopover = ({
  onSetSelfRating,
}: SelfRatingPopoverProps) => {
  return (
    <div className={styles.selfRatingPopover}>
      <div className={styles.title}>My understanding of the lesson</div>
      <div className={styles.selfRatingOptions}>
        {selfRatingOptions.map((option) => {
          return (
            <button
              key={option.rating}
              className={cx(styles.button, styles[option.color])}
              onClick={() => {
                onSetSelfRating(option.rating);
              }}
            >
              {option.rating}
            </button>
          );
        })}
      </div>
    </div>
  );
};
